export default __webpack_public_path__ + "static/media/Decima Mono W01 Regular.ed7267ac.ttf";